module.exports = __webpack_public_path__ + "img/delete-icon.e1a5217e.svg";